import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { downloadGuides } from "@/mocks/doumanData";

export default function DownloadSection() {
  const [active, setActive] = useState(0);
  const guide = downloadGuides[active];

  return (
    <section id="download" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="APP 下载"
          title="安卓 / 苹果 / 电脑，三种安装方式逐步说明"
          desc="安装客户端后可以离线缓存章节、接收更新提醒，弱网环境下也更稳定。下面按平台拆解每一步操作。"
        />

        <div className="mt-10 inline-flex p-1 rounded-full bg-background-50 border border-background-200" role="tablist" aria-label="选择平台">
          {downloadGuides.map((item, index) => (
            <button
              key={item.platform}
              type="button"
              role="tab"
              aria-selected={active === index}
              onClick={() => setActive(index)}
              className={`px-4 md:px-5 py-2 rounded-full text-sm font-bold transition-colors cursor-pointer whitespace-nowrap ${
                active === index
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              {item.platform}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2 p-6 md:p-8 rounded-lg bg-background-50 border border-background-200">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
                <i className={`${guide.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="font-heading font-bold text-lg text-foreground-950">{guide.platform} 安装步骤</h3>
            </div>
            <ol className="mt-6 space-y-5">
              {guide.steps.map((step, index) => (
                <li key={step} className="flex gap-4">
                  <span className="shrink-0 w-7 h-7 rounded-full bg-primary-100 text-primary-700 text-sm font-bold flex items-center justify-center">
                    {index + 1}
                  </span>
                  <p className="text-sm leading-relaxed text-foreground-700 pt-0.5">{step}</p>
                </li>
              ))}
            </ol>
          </div>

          <aside className="p-6 md:p-8 rounded-lg bg-foreground-950 text-background-50 flex flex-col">
            <span className="w-11 h-11 rounded-lg bg-secondary-500 text-foreground-950 flex items-center justify-center">
              <i className="ri-lightbulb-flash-line text-xl" aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 font-heading font-bold text-lg">安装小提醒</h3>
            <p className="mt-3 text-sm leading-relaxed text-background-100">{guide.note}</p>
            <ul className="mt-6 space-y-3 text-sm text-background-100">
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-accent-400 mt-0.5" aria-hidden="true"></i>
                建议连接稳定 Wi-Fi 后再下载安装包
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-accent-400 mt-0.5" aria-hidden="true"></i>
                安装失败时先清理手机剩余存储空间
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-accent-400 mt-0.5" aria-hidden="true"></i>
                客户端与网页版共用同一账号
              </li>
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}